import React, {useEffect, useState} from 'react';
import './Pagination.css';
import {BsFillCaretRightFill} from 'react-icons/bs';

function getWindowSize() {
    const {innerWidth, innerHeight} = window;
    return {innerWidth, innerHeight};
}

const Pagination = ({
                        division,
                        currentPage,
                        handleDayClick,
                        visible
                    }) => {
    // Pour probm et proad : 11 journées + 3 playoffs (Quart, Demi, Finale) = 14 pages
    // Pour proam : 18 journées + 2 playoffs (Demi, Finale) = 20 pages
    const computedTotalPage = (division === 'proam') ? 20 : 14;
    const pages = Array.from({length: computedTotalPage}, (_, i) => i + 1);

    const [startPage, setStartPage] = useState(0);
    const maxDayResponsive = 4;

    // Gestion de la réactivité
    const [windowSize, setWindowSize] = useState(getWindowSize());
    const [isResponsive, setIsResponsive] = useState(false);

    useEffect(() => {
        handleWindowResize();
        window.addEventListener('resize', handleWindowResize);
        return () => window.removeEventListener('resize', handleWindowResize);
    }, [division, computedTotalPage]);

    const handleWindowResize = () => {
        const size = getWindowSize();
        if (size.innerWidth > 1000) {
            resetPage();
            setIsResponsive(false);
        } else {
            if (!isResponsive) {
                setStartPage(currentPage);
                setIsResponsive(true);
            }
        }
        setWindowSize(size);
    };

    const handleChangePage = (e, value) => {
        e.preventDefault();
        if (startPage === 0 && value < 0) return false;
        if (startPage >= computedTotalPage - maxDayResponsive && value > 0) return false;
        setStartPage(startPage + value);
    };

    const resetPage = () => {
        setStartPage(0);
    };

    const getEndPage = () => {
        let max = computedTotalPage;
        if (windowSize.innerWidth <= 1000) {
            let result = startPage + maxDayResponsive;
            if (result > max) result = max;
            max = result;
        }
        return max;
    };

    // Indique si la page correspond à une phase de playoffs
    const isPlayOffDown = (page) => {
        // Pour probm et proad, les playoffs commencent après la 11ᵉ journée (pages 12, 13, 14)
        if ((division === 'probm' || division === 'proad') && page > 11) return true;
        // Pour proam, les playoffs commencent après la 18ᵉ journée (pages 19 et 20)
        if (division === 'proam' && page > 18) return true;
        return false;
    };

    // Renvoie le libellé correspondant si la page est une phase de playoffs
    const getPlayoffLabel = (page) => {
        if (division === 'probm' || division === 'proad') {
            if (page === 12) return windowSize.innerWidth >= 1000 ? "Quart de finale" : "1/4";
            if (page === 13) return windowSize.innerWidth >= 1000 ? "Demi-Finale" : "1/2";
            if (page === 14) return "Finale";
        } else if (division === 'proam') {
            if (page === 19) return windowSize.innerWidth >= 1000 ? "Demi-Finale" : "1/2";
            if (page === 20) return "Finale";
        }
        return null;
    };

    if (!visible) return null;

    return (
        <div className="pagination_component">
            <BsFillCaretRightFill className="calendar_arrow" size={32} style={{transform: 'rotate(180deg)'}}
                onClick={(e) => handleChangePage(e, -1)}/> {pages.slice(startPage, getEndPage()).map((page, index) => {
            const playoffLabel = isPlayOffDown(page) ? getPlayoffLabel(page) : null;
            return (
                <span key={index} className={
                    currentPage !== page
                        ? `calendar_days ${division} ${isPlayOffDown(page) ? 'offdown' : ''}`
                        : `calendar_days active ${division} ${isPlayOffDown(page) ? 'offdown' : ''}`
                } onClick={(e) => handleDayClick(e, page)}>
            {playoffLabel ? playoffLabel : `J${page}`}
          </span>
            );
        })} <BsFillCaretRightFill className="calendar_arrow" size={32} onClick={(e) => handleChangePage(e, 1)}/>
        </div>
    );
};

export default Pagination;
